import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=988405d4&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=ts&setup=true"
export * from "./Badge.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Badge.vue?vue&type=style&index=0&id=988405d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988405d4",
  null
  
)

export default component.exports